import { render, staticRenderFns } from "./BusinessReportsView.vue?vue&type=template&id=57515ff8"
import script from "./BusinessReportsView.vue?vue&type=script&lang=js"
export * from "./BusinessReportsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports